import api from "@/api/api";
import Room from "@/model/room";

interface RoomListResponseInterface {
  meta: {
    status: number,
    message: string
  },
  data: Room[]
}

export class roomApi extends api{
  constructor() {
    super();
    this.setup();
  }

  async list(parameters: any):Promise<Room[]> {
    const response = await this.getHttp().get<RoomListResponseInterface>(
      '/rooms',
      {
        params: parameters,
        data: {
          notLoading: true
        }
      }
    )

    if (response.status == 200) {
      return response.data.data.map((room) => {
        return new Room(room);
      });
    }
  }
}

export default new roomApi;